import { render, staticRenderFns } from "./NewsfeedPost.vue?vue&type=template&id=d9f2f766&"
import script from "./NewsfeedPost.vue?vue&type=script&lang=js&"
export * from "./NewsfeedPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports